<template>
  <TeaserAccountTile>
    <template v-slot:component>
      <PublicUsernameRetrievalContainer></PublicUsernameRetrievalContainer>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import PublicUsernameRetrievalContainer from '@/components/account-management/publicusernameretrieval/PublicUsernameRetrievalContainer.vue'
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
</script>
